/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Slide, Snackbar } from '@mui/material';

const DELAY = 10_000;

const CustomSnackbar = ({ index, severity, message, onSnackbarClose }) => {
  return (
    <Snackbar
      open
      autoHideDuration={DELAY}
      onClose={onSnackbarClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      style={{ bottom: `${8 + index * 56}px` }}
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'up' }}
    >
      <Alert
        onClose={onSnackbarClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

CustomSnackbar.defaultProps = {
  severity: 'info',
  message: '',
  onSnackbarClose: () => null,
  index: 0,
};

CustomSnackbar.propTypes = {
  index: PropTypes.number,
  severity: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onSnackbarClose: PropTypes.func,
};

export default CustomSnackbar;
